module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7lIyq"))).then(() => module.bundle.root('gtEzC'));